<template>
  <div id="live_list">
    <div class="bread">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{path: '/watch_index'}">缴费客户观看直播情况</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bottom cont">
      <div class="titlebox">
        <div class="title">缴费客户观看直播情况</div>
        <div class="notice">
          <span class="right_grid">
            <span class="refresh" @click="refresh">刷新</span>

          </span>
        </div>
      </div>
      <div class="string"></div>
      <div class="navs">
        <el-form class="course_search_form" ref="course_search_form" size="large">
          <el-form-item label="客服老师">
            <el-select v-model="search.kf" style="width: 230px" @change="getData">
              <el-option v-for="(item, index) in kf_list" :key="index" :label="item.yhmc"
                :value="item.wx_account"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直播主题" style="margin-left: 16px;">
            <el-select v-model="search.livingid" style="width: 230px" @change="getData">
              <el-option v-for="(item, index) in living_list" :key="index" :label="item.theme"
                :value="item.livingId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源进线时间" style="margin-left: 16px;">
            <el-date-picker v-model="search.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="getData" format="YYYY-MM-DD" value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户备注" style="margin-left: 16px;">
            <el-input v-model="search.input" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 16px;">
            <el-button type="primary" @click="getData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表 -->
      <div class="table_box">
        <el-table v-loading="loading" :data="tableData" stripe style="width: 98%; margin: 0 auto;" :height="tableHeight"
          :header-cell-style="{backgroundColor: '#FAFAFA'}" @sort-change="customSort">
          <el-table-column label="序号" width="60" align="center" fixed="left">
            <template #default="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户备注" prop="remark" align="center" fixed="left">
            <template #default="scope">
              <span class="caozuo" @click="gotoPage(scope.row)">{{ scope.row.remark	}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户头像" prop="img" align="center" fixed="left">
            <template #default="scope">
              <img :src="scope.row.avatar" :style="{width: '40px',height: '40px'}" />
            </template>
          </el-table-column>
          <el-table-column label="客服老师" width="120" align="left" fixed="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.yhmc}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="learn_count" sortable="custom" label="观看直播数" align="center" fixed="left"
            :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.learn_count}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="all_learn_time" sortable="custom" label="直播观看总时长" align="left">
            <template #default="scope">
              <span>{{scope.row.all_learn_time_new}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="avg_learn_time" sortable="custom" label="平均观看时长" align="center">
            <template #default="scope">
              <span>{{scope.row.avg_learn_time_new}}</span>
            </template>
          </el-table-column>

        </el-table>
        <el-row class="paging_box" justify="space-between">
          <el-pagination class="paging" @size-change="sizeChange" @current-change="currentChange"
            :current-page="page.current" :page-sizes="page.pageSizes" :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import './assets/less/list.less';
  import list_model from "./model/model";
  import common_model from '@/common/model';
  import moment from "moment/moment";
  import {
    reactive
  } from "vue";
  var that = null
  export default {
    components: {},
    data() {
      that = this
      return {
        type: that.$route.query.type || '', //部门类型
        loading: false,
        tableHeight: 350,
        activeName: 'watch_index',
        kf_list: [],
        living_list:[],
        tableData: [],
        page: {
          loading: false,
          pageSize: 50,
          total: 0,
          size: 10,
          current: 1,
          pageSizes: [10, 20, 50, 100],
        },
        sort:null,
        search: {
          kf: "",
          livingid:"",
          input:"",
          date: []
        }
      }
    },
    mounted() {
      that.$nextTick(() => {
        that.tableHeight = document.querySelector('.table_box').clientHeight - 34;
        that.init()
      });
    },
    methods: {
      init() {
        //用户权限处理
        common_model.getUserInfo().then((res) => {
          that.userInfo = res;
          that.setDefaultDateRange()
          that.get_kf_list()
          that.getLivingList()
        });
      },
      customSort({ column, prop, order }) {
        let params = {}
        that.page.current = 1
        if (order != null) {
          params.sort_field = prop
          switch (order) {
            case "ascending":
              params.sort = 1
              break;
            case "descending":
              params.sort = -1
              break;
          }
          that.sort = params
          that.getData()
        } else {
          that.sort = null
          that.getData()
        }
      },
      getLivingList() {
        that.loading = true;
        let params = reactive({
          pageIndex: 1,
          pageSize: 30,
          type: 0
        })
        list_model.get_e_live_list(params, "_1").then(res => {
          that.loading = false;
          if (res.code === 0) {
            let all = {theme:"全部",livingId:""}
            let list = res.list
            list.unshift(all);
            that.living_list = list;
          }
        });
      },
      setDefaultDateRange() {
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 当月 1 号
        const endOfToday = new Date(today); // 今天

        // 格式化日期为 YYYY-MM-DD
        const formatDate = (date) => {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
          const d = String(date.getDate()).padStart(2, '0');
          return `${y}-${m}-${d}`;
        };

        that.search.date = [formatDate(startOfMonth), formatDate(endOfToday)];
      },
      get_kf_list() {
        list_model.get_kf_list().then(res => {
          that.loading = false;
          if (res.code === 0) {
            let list = res.list
            let all = {
              "yhmc": "全部",
              "wx_account": ""
            }
            if (that.userInfo.bmbm.startsWith("hjkf")) {
              if (that.userInfo.yhid == "1998368")
                list.unshift(all);
              else {
                list = list.filter(item => item.yhid == that.userInfo.yhid)
                that.search.kf = list[0].wx_account
              }
            } else
              list.unshift(all);
            that.kf_list = list

            that.getData()
          }
        });
      },
      /**
       * 获取列表数据
       */
      getData() {
        that.loading = true;
        let params = null
        let oldParams = {
          begin_time: that.search.date[0],
          end_time: that.search.date[1],
          userid: that.search.kf,
          pageIndex: that.page.current,
          pageSize: that.page.size,
          livingid: that.search.livingid,
          nickname: that.search.input
        }
        if (that.sort!=null)
          params = { ...oldParams, ...that.sort }
        else
          params = oldParams
        list_model.get_watch_living_info_new(reactive(params)).then(res => {
          that.loading = false;
          if (res.code === 0) {
            let list = res.list
            for (let i in list) {
              let item = list[i]
              item.all_learn_time_new = that.formatSecondsToHMS(item.all_learn_time)
              item.avg_learn_time_new = that.formatSecondsToHMS(item.avg_learn_time)
            }

            that.tableData = res.list;
            that.page.total = res.total;
          }
        });
      },
      formatSecondsToHMS(seconds) {
        // 将小数秒数转换为整数秒数
        const new_seconds = Math.round(seconds);
        // 计算小时数
        const hours = Math.floor(new_seconds / 3600);
        // 计算剩余的分钟数
        const minutes = Math.floor((new_seconds % 3600) / 60);
        // 计算剩余的秒数
        const secs = new_seconds % 60;

        // 格式化输出，确保每个部分都是两位数（如果需要）
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = secs.toString().padStart(2, '0');
        let result = ""
        if (formattedHours != "00") {
          result = `${formattedHours}小时`
        }
        if (formattedMinutes != "00") {
          result += `${formattedMinutes}分`
        }
        if (formattedSeconds != "00") {
          result += `${formattedSeconds}秒`
        }
        if (result == "") {
          result = "0秒"
        }
        // 返回格式化的字符串
        return result
      },
      /* 数据刷新 */
      refresh() {
        that.getData()
      },
      /**
       * 分页-改变分页大小
       */
      sizeChange(v) {
        that.page.size = v;
        that.page.current = 1;
        that.getData();
      },
      /**
       * 分页-当前页数据刷新
       */
      currentChange(v) {
        that.page.current = v;
        that.getData();
      },
      /**
       * 时间格式化
       * @param time 以秒为单位的时间戳
       */
      formatDate(date) {
        return moment(date).format('YYYY-MM-DD')
      },
      gotoPage(item) {
        let userInfo = that.userInfo
        let url = "/watch_detail?unionid=" + item.unionid + "&userid=" + item.wx_account
        window.location.href = url
      },
    },
    filters: {

    }
  }
</script>

<style>
  * {
    padding: 0;
  }
</style>
